import { render, staticRenderFns } from "./scan_reocrd_page.vue?vue&type=template&id=098e6f5d&scoped=true"
import script from "./scan_reocrd_page.vue?vue&type=script&lang=js"
export * from "./scan_reocrd_page.vue?vue&type=script&lang=js"
import style0 from "./scan_reocrd_page.vue?vue&type=style&index=0&id=098e6f5d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e6f5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098e6f5d')) {
      api.createRecord('098e6f5d', component.options)
    } else {
      api.reload('098e6f5d', component.options)
    }
    module.hot.accept("./scan_reocrd_page.vue?vue&type=template&id=098e6f5d&scoped=true", function () {
      api.rerender('098e6f5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/source/scan_reocrd_page.vue"
export default component.exports